<!--
Logout screen
@author bmk11u
-->
<template>
  <div>
    <div id="loginLogo">
      <img class="loginLogoImg" src="@/assets/UofG_App_Logo.svg" alt="University of Glasgow Logo" height="110px"/>
    </div>
    <Spinner ref="spinner_ref" />
  </div>
</template>

<script setup>
import axios from 'axios'
import * as lst from '@/components/localStorage.js'

import { useIDBCommon } from '@/composables/IDBCommon.js'
import { useRouter } from 'vue-router'
import { ref, onMounted } from 'vue'

const router = useRouter()
const { deleteFor } = useIDBCommon()
const spinner_ref = ref(null)

 onMounted (() => {
  // BYPASS THIS SCREEN
  spinner_ref.value.spin()
  axios.delete('/timetable/login')
    .then(() => {
      spinner_ref.value.stop()
      // remove idb data for user if any
      const guid = lst.getUserGuid()
      if (typeof guid !== 'undefined' && guid !== null) {
        console.log('removing stored data for ' + guid)
        deleteFor(guid)
      }
      //logout and keep any unexpired notices (true)
      lst.clearAll(true)
      router.push('login')
    })
    .catch(() => {
      router.push('index')
    })
 }) 
</script>

<style scoped>
#loginLogo {
  height:200px;
  background-color: var(--uog-dark-blue);
  text-align:center;
}
</style>
